// Page-scoped bundle for /talent-flows ONLY — force-graph (canvas node-link
// renderer, ~bundled d3-force) is far too heavy for the sitewide application
// bundle. The view loads this via javascript_include_tag; talent_flow_controller
// waits for window.ForceGraph before drawing.
import ForceGraph from "force-graph"
import { forceCollide } from "d3-force"

window.ForceGraph = ForceGraph
window.ForceGraphCollide = forceCollide
